import { FilterTypes } from 'Core/interfaces'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import { Mou, MouFilterFields, MouSearchResultFields } from 'Portals/Customer/entities'
import { mouNumberEntityToLabelValue, mouSubjectEntityToLabelValue } from 'Portals/Customer/utils'
import i18n from 'Portals/Customer/utils/i18nService'

export const getSearchConfig = (): Mou.Search.Config => ({
	[MouSearchResultFields.searchBySubject]: {
		label: i18n.t('pages:mou.filters.searchBySubject'),
		apiFieldName: MouSearchResultFields.searchBySubject,
		apiSearchFieldName: 'MouId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.subject,
		UrlParamLabel: UrlParamsLabel.subjectLabel,
		customOptionFormatter: mouSubjectEntityToLabelValue
	},
	[MouSearchResultFields.searchByMouNumber]: {
		label: i18n.t('pages:mou.filters.searchByMouNumber'),
		apiFieldName: MouSearchResultFields.searchByMouNumber,
		apiSearchFieldName: 'MouId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.mouNumber,
		UrlParamLabel: UrlParamsLabel.mouNumberLabel,
		customOptionFormatter: mouNumberEntityToLabelValue
	}
})

export const getFiltersConfig = (): Mou.Filter.Config => ({
	[MouFilterFields.serviceSite]: {
		label: i18n.t('pages:mou.filters.serviceSite'),
		apiFilterFieldName: MouFilterFields.serviceSite,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	},
	[MouFilterFields.issuedDateFrom]: {
		label: i18n.t('pages:mou.filters.issuedDateFrom'),
		apiFilterFieldName: MouFilterFields.issuedDateFrom,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.issuedDateFrom,
		defaultValue: null
	},
	[MouFilterFields.issuedDateTo]: {
		label: i18n.t('pages:mou.filters.issuedDateTo'),
		apiFilterFieldName: MouFilterFields.issuedDateTo,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.issuedDateTo,
		defaultValue: null
	}
})
